<fieldset [formGroup]="group" class="in-two-columns">
  <legend class="small-legend">{{ TITLE + "TITLE" | translate }}:</legend>

  <!-- Type -->

  <mat-form-field>
    <app-easy-select
      formControlName="type"
      [label]="TITLE + 'TYPE' | translate"
      [translatePrefixForSelected]="'PRODUCTS.COFFEE_TYPE.'"
      [labelAttribute]="'name'"
      [valueAttribute]="'value'"
      [hasEmptyOption]="false"
      [options]="type | toSelectOption: 'PRODUCTS.COFFEE_TYPE.'"
      (ngModelChange)="onTypeChange($event)"
    >
    </app-easy-select>
  </mat-form-field>

  <!-- !Type -->

  <!-- Appearance form -->

  <mat-form-field *ngIf="getCtrl('appearanceForm')">
    <app-easy-select
      formControlName="appearanceForm"
      [label]="TITLE + 'APPEARANCE_FORM' | translate"
      [translatePrefixForSelected]="'PRODUCTS.COFFEE_APPEARANCE_FORM.'"
      [labelAttribute]="'name'"
      [hasEmptyOption]="false"
      [valueAttribute]="'value'"
      [options]="
        appearanceForm | toSelectOption: 'PRODUCTS.COFFEE_APPEARANCE_FORM.'
      "
    >
    </app-easy-select>
  </mat-form-field>

  <!-- !Appearance form -->

  <!-- Processing level -->

  <mat-form-field *ngIf="getCtrl('processingLevel')">
    <app-easy-select
      formControlName="processingLevel"
      [label]="TITLE + 'PROCESSING_LEVEL' | translate"
      [translatePrefixForSelected]="'PRODUCTS.COFFEE_PROCESSING_LEVEL.'"
      [labelAttribute]="'name'"
      [valueAttribute]="'value'"
      [hasEmptyOption]="false"
      [options]="
        processingLevel | toSelectOption: 'PRODUCTS.COFFEE_PROCESSING_LEVEL.'
      "
    >
    </app-easy-select>
  </mat-form-field>

  <!-- !Processing level -->

  <!-- Caffeine content -->

  <mat-form-field *ngIf="getCtrl('processingLevel')">
    <app-easy-select
      formControlName="caffeineContent"
      [label]="TITLE + 'CAFFEINE_CONTENT' | translate"
      [translatePrefixForSelected]="'PRODUCTS.COFFEE_CAFFEINE_CONTENT.'"
      [labelAttribute]="'name'"
      [valueAttribute]="'value'"
      [hasEmptyOption]="false"
      [options]="
        caffeineContent | toSelectOption: 'PRODUCTS.COFFEE_CAFFEINE_CONTENT.'
      "
    >
    </app-easy-select>
  </mat-form-field>

  <!-- !Caffeine content -->
</fieldset>
